<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <!-- NOTE TOOLBAR -->
      <div>
        <v-toolbar dark color="primary" :elevation="elevation">
          <v-toolbar-title>Annotation</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="Close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </div>
      <!-- NOTE CONTENT -->
      <div class="main-layout">
        <div class="grid-gallery">
          <div
            :class="[
              `grid-item`,
              `${items.length <= 1 ? 'grid-item-single' : ''}`,
            ]"
            id="viewer-image"
          >
            <v-card :elevation="elevation" style="height: 100%; width: 100">
              <squareOnImage
                v-if="
                  localItems[0] != undefined && localItems[0].type == 'single'
                "
                :src="localItems[index]?.src"
                :boxs="boxs"
                :brightness="localItems[index]?.adjusts.brightness"
                :contrast="localItems[index]?.adjusts.contrast"
                :loading="loading"
              >
              </squareOnImage>

              <dwv
                v-else
                v-model="localItems"
                @updateDraw="onUpdateDraw"
                :annotation="annotationLocal"
                :activeTools="[
                  'scroll',
                  'zoomandpan',
                  'windowlevel',
                  'side',
                  'reset',
                  'cm',
                  'wl',
                  'drawrect',
                  'drawellipse',
                  'drawruler',
                  'drawcircle',
                  'drawarrow',
                  'drawprotractor',
                  'drawroi',
                  'drawfreehand',
                  'info',
                ]"
              >
              </dwv>
            </v-card>
          </div>

          <div class="grid-item">
            <v-card :elevation="elevation" class="card-item">
              <v-card-title>Annotation List</v-card-title>
              <v-card-text class="card-text">
                <!-- <div v-for="(i,idx) in items" :key="idx">{{ i.series_id }}</div> -->
                <v-list dense>
                  <v-list-item-group color="primary">
                    <v-list-item
                      v-for="(
                        value, name, index
                      ) in annotation?.drawingsDetails"
                      :key="name"
                    >
                      <v-list-item-icon>
                        <v-icon color="primary">mdi-label-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ value.meta.textExpr }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                          v-text="index"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
// REF https://codepen.io/wellingguzman/pen/BxVKRE?editors=1010
import squareOnImage from '@/components/squareOnImage_v2.vue'
// import chatbox from '@/components/ChatBox.vue'
import dwv from '@/components/Dwv.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    squareOnImage,
    // chatbox,
    dwv
  },
  data () {
    return {
      index: 0,
      loading: false,
      boxs: [],
      elevation: 4, // TODO Global elevation all Card
      // dialog: true,
      notifications: false,
      sound: true,
      widgets: false,
      details: [
        { text: 'ID', value: 'job_id' },
        { text: 'H/N', value: 'po' },
        { text: 'ชื่อผู้ป่วย', value: 'pn' },
        { text: 'วันที่ x-ray', value: 'da' },
        // { text: 'ชื่อไฟล์', value: 'xxxxxxxxxxxx.jpg' },
        { text: 'วันที่อัปโหลด', value: 'create_date' },
        // { text: 'ผู้อัปโหลด', value: 'create_by' },
        { text: 'Type', value: 'type' },
        { text: 'Series ID', value: 'series_id' }
      ],
      adjusts: [
        { text: 'ความสว่าง', value: 100, key: 'brightness' },
        { text: 'ความเข้ม', value: 100, key: 'contrast' }
      ],
      elementViewImage: null,
      labels: []
      // annotation: null
      // diagnosis: [
      //   {
      //     text: 'Cardiomegaly',
      //     value: 50,
      //     active: false,
      //     items: [
      //       {
      //         text: 'A1',
      //         value: 50,
      //         xy: [
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 10 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 20 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 30 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 40 }
      //         ]
      //       }
      //     ]
      //   },
      //   {
      //     text: 'Pneumothorax',
      //     value: 50,
      //     active: false,
      //     items: [
      //       // {
      //       //   text: 'A1',
      //       //   value: 50,
      //       //   xy: [
      //       //     { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 10 },
      //       //     { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 20 },
      //       //     { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 30 },
      //       //     { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 40 }
      //       //   ]
      //       // }
      //     ]
      //   },
      //   {
      //     text: 'Tuberculosis',
      //     value: 50,
      //     active: false,
      //     items: [
      //       {
      //         text: 'E1',
      //         value: 50,
      //         xy: [
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 10 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 20 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 30 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 40 }
      //         ]
      //       },
      //       {
      //         text: 'E2',
      //         value: 50,
      //         xy: [
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 10 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 20 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 30 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 40 }
      //         ]
      //       },
      //       {
      //         text: 'E3',
      //         value: 50,
      //         xy: [
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 10 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 20 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 30 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 40 }
      //         ]
      //       }
      //     ]
      //   }
      // ]
    }
  },
  props: {
    hospital_id: {
      type: String
    },
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    },
    annotation: {
      type: Object,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => [
        // {
        //   job_id: '',
        //   po: '',
        //   pn: '',
        //   da: '',
        //   create_date: '',
        //   create_by: '',
        //   series_id: '',
        //   type: ''
        // }
      ]
    },
    detailItem: {
      type: Object,
      default: () => {
        return {
          job_id: '-',
          po: '-',
          pn: '-',
          da: '-',
          create_date: '-',
          create_by: '-'
        }
      }
    },
    src: {
      type: String,
      default: ''
    },
    processes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(['storeGetUserInfo']),
    // boxs () {
    //   // { xmin: 100, ymin: 100, xmax: 200, ymax: 200, confident: 100 }
    //   let b = Object.assign([])
    //   for (const i of this.processes) {
    //     if (i.results.length > 0) {
    //       b = [...b, ...i.results]
    //     }
    //   }
    //   return b
    // },
    localItems: {
      get () {
        return this.items
      },
      set (val) {
        this.$emit('update:items', val)
        return val
      }
    },
    annotationLocal: {
      get () {
        return this.annotation
      },
      set (newValue) {
        this.$emit('update:annotation', newValue)
      }
    },
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        return val
      }
    },
    listDicomFile () {
      return this.localItems.map((e) => e.dicom)
    }
  },
  // watch: {
  //   async dialog (newVal) {
  //     if (newVal) {
  //       await this.initAnnotation()
  //     }
  //   }
  // },
  methods: {
    // async initAnnotation () {
    //   this.annotationLocal = null
    //   this.loading = true
    //   const { hospitalId, seriesId } = this.getHyperValue()
    //   if (seriesId !== '' && hospitalId !== '') {
    //     const res = await this.getAnnotation(hospitalId, seriesId)
    //     if (res.status) {
    //       if (res.data.length > 0) {
    //         this.annotationLocal = res.data[0].annotation
    //       }
    //       this.notification.success({
    //         message: 'Success',
    //         description: res.message,
    //         placement: 'bottomRight'
    //       })
    //     } else {
    //       this.notification.error({
    //         message: 'Error',
    //         description: res.message,
    //         placement: 'bottomRight'
    //       })
    //     }
    //   }
    //   this.loading = false
    // },
    // getHyperValue () {
    //   let seriesId = ''
    //   const hospitalId = this.$route.params.hospital_id
    //   if (this.items.length > 0) {
    //     seriesId = this.items[0].series_id
    //   }
    //   return { hospitalId: hospitalId, seriesId: seriesId }
    // },
    async onUpdateDraw (val) {
      this.annotationLocal = val
      this.$emit('updateDraw', val)
      // const { hospitalId, seriesId } = this.getHyperValue()
      // if (seriesId !== '' && hospitalId !== '') {
      //   const res = await this.updateAnnotation(hospitalId, seriesId, val)
      //   if (res.status) {
      //     // NOTE สำหรับทำ Local Update
      //     this.annotationLocal = val
      //     this.notification.success({
      //       message: 'Success',
      //       description: res.message,
      //       placement: 'bottomRight'
      //     })
      //   } else {
      //     this.notification.error({
      //       message: 'Error',
      //       description: res.message,
      //       placement: 'bottomRight'
      //     })
      //   }
      // } else console.warn('error')
      // this.annotation = JSON.parse(JSON.stringify(val))
    },
    onCreateComment (val) {
      // NOTE ทำการ DTO ข้อมูลก่อนส่งไปยัง Parent เพื่อ Call API
      this.$emit('createComment', {
        ...val,
        ...{
          user_id: this.storeGetUserInfo.user_id,
          job_id: this.localItems[this.index]?.job_id
        }
      })
    },
    onCreateSubComment (val) {
      // console.log(val)
      this.$emit('createSubComment', {
        ...val,
        ...{
          user_id: this.storeGetUserInfo.user_id,
          job_id: this.localItems[this.index]?.job_id
        }
      })
    },
    onUpdateComment (val) {
      // NOTE
      this.$emit('updateComment', val)
    },
    onDeleteMainComment (val) {
      // NOTE
      this.$emit('deleteMainComment', {
        ...val,
        ...{
          user_id: this.storeGetUserInfo.user_id
        }
      })
    },
    onDeleteSubComment (val) {
      this.$emit('deleteSubComment', {
        ...val
        // ...{
        //   user_id: this.storeGetUserInfo.user_id
        // }
      })
    },
    Close () {
      // TODO Reset Value
      this.boxs = []
      this.index = 0
      this.dialog = !this.dialog
      // this.adjusts = JSON.parse(
      //   JSON.stringify([
      //     { text: 'ความสว่าง', value: 100 },
      //     { text: 'ความเข้ม', value: 100 }
      //   ])
      // )
    }

    // FIX
    // mouseOver (event) {
    //   // console.log('mouse over')
    //   // this.elementViewImage.addEventListener('wheel', this.mouseWheel)
    // }

    // FIX
    // mouseLeave (event) {
    //   // console.log('mouse leave')
    //   // this.elementViewImage.addEventListener(
    //   //   'wheel',
    //   //   this.debounce(this.mouseWheel, 100)
    //   // )
    // }

    // FIX
    // debounce (fn, d) {
    //   let timer
    //   return function () {
    //     const context = this
    //     const args = arguments
    //     clearTimeout(timer)
    //     timer = setTimeout(() => {
    //       fn.apply(context, args)
    //     }, d)
    //   }
    // }

    // FIX
    // mouseWheel (event) {
    //   if (event.deltaY > 0) {
    //     if (this.index < this.localItems.length - 1) this.index++
    //   }
    //   if (event.deltaY < 0) {
    //     if (this.index > 0) this.index--
    //   }
    // }

    // FIX
    // async onDrawRectangle (val) {
    //   this.labels.push(val.children[0].children[0]._partialText)
    //   console.log('emit', val.children[0].children[0]._partialText, val)
    // }
  },
  mounted () {
    //
  }
}
</script>

<style lang="css" scoped>
.main-layout {
  /* background: blue; */
  /* background: var(--v-bgPrimary-base); */
  height: calc(100vh - 64px) !important;
  width: 100%;
  overflow: auto;
}

.full-width-height {
  /* position: relative !important; */
  height: 100% !important;
  width: 100% !important;
  /* background-color: pink; */
  padding: 0;
  margin: 0;
}

::v-deep .card-item {
  height: 100% !important;
  width: 100% !important;
  /* background-color: green !important; */
}
.column-full {
  height: 100%;
}

.card-text {
  overflow: auto;
  height: calc(100% - 64px - 12px);
  padding-bottom: 0;
}

/* .v-image {
  border-radius: inherit;
}

.content {
  padding: 12px;
}
.content-details {
  height: 60%;
}

.content-adjusts {
  height: 40%;
}

.content-diagnosis {
  height: 40%;
}
.content-comments {
  height: 60%;
} */

.text-warning {
  color: var(--v-warning-base) !important;
}
.text-success {
  color: var(--v-success-base) !important;
}

.grid-gallery {
  background-color: rgb(225, 225, 225);
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0.5rem;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: repeat(9, 1fr);
  grid-auto-rows: dense;
  grid-auto-flow: dense;
  grid-gap: 0.5rem;
  color: #fff;
  /* text-align: center; */
}

.grid-item {
  /* background-color: #1c304e; */
  border-radius: 1rem;
  overflow: hidden;
  /* overflow-y: auto; */
  width: 100%;
  height: 100%;
}
/* .grid-item:nth-child(1) {
  grid-row: span 6;
  grid-column: span 2;
} */
.grid-item-series {
  grid-row: span 10;
  grid-column: span 2;
}
.grid-item:nth-child(1) {
  grid-row: span 10;
  grid-column: span 8;
}

.grid-item:nth-child(2) {
  grid-row: span 10;
  grid-column: span 2;
}
/*
.grid-item:nth-child(4) {
  grid-row: span 6;
  grid-column: span 2;
}

.grid-item:nth-child(5) {
  grid-row: span 4;
  grid-column: span 2;
}

.grid-item:nth-child(6) {
  grid-row: span 2;
  grid-column: span 6;
} */

.grid-item-single {
  grid-row: span 10 !important;
}
/* .grid-item:nth-child(3),
.grid-item:nth-child(4) {
    grid-row: span 2;
} */

/* เมื่อเป็นน้อยกว่า lg */
@media only screen and (max-width: 1263px) {
  /* .content-details,
  .content-adjusts,
  .content-diagnosis,
  .content-comments {
    height: auto;
  }

  .column-full {
    height: auto;
  } */

  .grid-gallery {
    /* background-color: yellow; */
    grid-template-columns: 100%;
    grid-template-rows: auto;
  }
}
</style>
